import Vue from 'vue'
import Router from 'vue-router'
import dropList from '@/components/dropList'
import MovementStatus from './views/MovementStatus'
import MovementStatusDetail from './views/MovementStatusDetail'
import MovementShift from './views/MovementShift'
import StationList from './views/StationList'
import MemberList from './views/MemberList'
import MonthWorkCount from './views/MonthWorkCount'
import MemberListDetail from './views/MemberList_Detail'
import MemberListOrderAndDetail from './views/MemberList_OrderAndDetail'
import MemberRecOrdOrOrderDetail from './views/MemberList_RecordOrOrderDetail'
import StationListRegistration from './views/StationList_Registration'
import mainLayout from './layouts/mainLayout'
import rightLayout from './layouts/rightLayout'
import VehicleList from './views/VehicleList'
import UserLogin from './views/UserLogin'
import ShiftLogin from './views/ShiftLogin'
import RouteShiftLogin from './views/RouteShiftLogin'
import VehicleLogin from './views/VehicleLogin'
import VehicleEditor from './views/VehicleEditor'
import VehicleSetting from './views/VehicleSetting'
import VehicleDetail from './views/VehicleDetail'
import VehicleBlockEditor from './views/VehicleBlockEditor'
import passengerReservation from './views/passengerReservation'
import passengerReservationDetail from './views/passengerReservationDetail'
import StationDetail from './views/StationDetail'
import MovementShiftDetail from './views/MovementShiftDetail'
// import MovementShiftPrintPdf from './views/MovementShiftPrintPdf'

// by ljc
import EventGenerate from './views/Event_Generate'
import ShiftEndDetail from './views/ShiftEndDetail'
import UserEditor from './views/UserEditor'
import ShiftWithEventDetail from './views/ShiftWithEventDetail'
// by ljc
// YKQ.
import RouteEvent from './views/RouteEvent'
import EditRouterInfo from './views/EditRouterInfo'
import NewRouteLogin from './views/NewRouteLogin'

// by gedc
import ReservationStatus from './views/ReservationStatus'
import RouteList from './views/RouteList'
import DriverList from './views/DriverList'
import MessageInfoList from './views/MessageInfoList'
import DriverScheduleList from './views/DriverScheduleList'
import OneDriverSchedule from './views/OneDriverSchedule'
import DriverShiftEndDetail from './views/DriverShiftEndDetail'
import DriverShiftWithEventDetail from './views/DriverShiftWithEventDetail'
import DriverCard from './views/DriverCard'

// by gedc
import login from './views/Login'
import ShiftEditor from './views/ShiftEditor'
import ShiftAdd from './views/ShiftAdd'

// 2022機能改善 by dbc
import EditMovementWork from './views/EditMovementWork'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    // 下面是包含头和右边部分路由（mainLayout）和只包含左边路由（rightLayout）的layout测试
    // ---------------------layout测试 开始-----------------
    { path: '/mainLayout', name: 'mainLayout', component: mainLayout },
    { path: '/rightLayout', name: 'rightLayout', component: rightLayout },
    // ---------------------layout测试 结束-----------------

    // ---------------------之前的页面路由 开始-----------------
    { path: '/login', name: 'login', component: login },
    // 重定向
    { path: '/', redirect: '/login' },
    { path: '/MovementStatus', name: 'MovementStatus', component: MovementStatus },
    { path: '/MovementStatusDetail', name: 'MovementStatusDetail', component: MovementStatusDetail },
    { path: '/MovementShift', name: 'MovementShift', component: MovementShift },
    { path: '/StationList', name: 'StationList', component: StationList },
    { path: '/VehicleList', name: 'VehicleList', component: VehicleList },
    { path: '/MemberListDetail', name: 'MemberListDetail', component: MemberListDetail },
    { path: '/StationListRegistration', name: 'StationListRegistration', component: StationListRegistration },
    { path: '/dropList', name: 'dropList', component: dropList },
    { path: '/passengerReservation', name: 'passengerReservation', component: passengerReservation },
    { path: '/passengerReservationDetail', name: 'passengerReservationDetail', component: passengerReservationDetail },
    { path: '/ReservationStatus', name: 'ReservationStatus', component: ReservationStatus },
    { path: '/RouteList', name: 'RouteList', component: RouteList },
    { path: '/MessageInfoList', name: 'MessageInfoList', component: MessageInfoList },
    // 之前的路由及测试路由结束

    // 添加layout后路由
    //  ------------------开始------------------
    { path: '/MemberList', name: 'MemberList', component: MemberList },
    { path: '/MonthWorkCount', name: 'MonthWorkCount', component: MonthWorkCount },
    { path: '/DriverList', name: 'DriverList', component: DriverList },
    { path: '/MemberListOrderAndDetail', name: 'MemberListOrderAndDetail', component: MemberListOrderAndDetail },
    { path: '/UserLogin', name: 'UserLogin', component: UserLogin },
    { path: '/ShiftLogin', name: 'ShiftLogin', component: ShiftLogin },
    { path: '/RouteShiftLogin', name: 'RouteShiftLogin', component: RouteShiftLogin },
    { path: '/VehicleLogin', name: 'VehicleLogin', component: VehicleLogin },
    { path: '/VehicleEditor', name: 'VehicleEditor', component: VehicleEditor },
    { path: '/VehicleSetting', name: 'VehicleSetting', component: VehicleSetting },
    { path: '/VehicleDetail', name: 'VehicleDetail', component: VehicleDetail },
    { path: '/VehicleBlockEditor', name: 'VehicleBlockEditor', component: VehicleBlockEditor },
    { path: '/MemberRecOrdOrOrderDetail', name: 'MemberRecOrdOrOrderDetail', component: MemberRecOrdOrOrderDetail },
    { path: '/MovementShiftDetail', name: 'MovementShiftDetail', component: MovementShiftDetail },
    // { path: '/MovementShiftPrintPdf', name: 'MovementShiftPrintPdf', component: MovementShiftPrintPdf },
    { path: '/StationDetail', name: 'StationDetail', component: StationDetail },
    // by ljc
    { path: '/EventGenerate', name: 'EventGenerate', component: EventGenerate },
    { path: '/ShiftEndDetail', name: 'ShiftEndDetail', component: ShiftEndDetail },
    { path: '/UserEditor', name: 'UserEditor', component: UserEditor },
    { path: '/ShiftWithEventDetail', name: 'ShiftWithEventDetail', component: ShiftWithEventDetail },
    { path: '/ShiftEditor', name: 'ShiftEditor', component: ShiftEditor },
    { path: '/ShiftAdd', name: 'ShiftAdd', component: ShiftAdd },
    // YKQ——————————————————————————————————————————
    { path: '/RouteEvent', name: 'RouteEvent', component: RouteEvent },
    { path: '/EditRouterInfo', name: 'EditRouterInfo', component: EditRouterInfo },
    { path: '/NewRouteLogin', name: 'NewRouteLogin', component: NewRouteLogin },
    // ——————————————————————————————————————————————
    { path: '/DriverScheduleList', name: 'DriverScheduleList', component: DriverScheduleList },
    { path: '/OneDriverSchedule', name: 'OneDriverSchedule', component: OneDriverSchedule },
    { path: '/DriverShiftEndDetail', name: 'DriverShiftEndDetail', component: DriverShiftEndDetail },
    { path: '/DriverShiftWithEventDetail', name: 'DriverShiftWithEventDetail', component: DriverShiftWithEventDetail },
    { path: '/DriverCard', name: 'DriverCard', component: DriverCard },
    // -------------------结束------------------
    
    // 2022機能改善 by dbc 
    { path: '/EditMovementWork', name: 'EditMovementWork', component: EditMovementWork },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js